import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import * as MgmActions from '../actions/mgm.actions';

export const featureKey = 'mgm';

/**
 * @ngrx/entity provides a predefined interface for handling
 * a structured dictionary of records. This interface
 * includes an array of ids, and a dictionary of the provided
 * model type by id. This interface is extended to include
 * any additional interface properties.
 */
export interface State {
  loading: boolean;
  error: string;
  config: any;
}

/**
 * getInitialState returns the default initial state
 * for the generated entity state. Initial state
 * additional properties can also be defined.
 */
export const initialState: State = {
  loading: true,
  error: null,
  config: null,
};

export const reducer = createReducer(
  initialState,
  on(MgmActions.retrieve, (state) => ({...state, loading: true})),
  on(MgmActions.retrieveSuccess, (state, { config }) => ({...state, config, loading: false, error: null})),
  on(MgmActions.retrieveFailure, (state, {error}) => ({...state, error}))
);
